import { safelyParseJSON } from '@egr/xbox/utils/Json';

import { ajax } from '@egr/wcf/modules/utils/async';

function getUploadUrl(baseUrl: string, filename: string, apiVersion: 'v1' | 'v2' = 'v1'): string {
    return baseUrl + '/EAIWS/plugins/FileStorage/' + apiVersion + '/' + filename;
}

export function uploadContent(baseUrl: string, filename: string, content: ArrayBuffer, apiVersion: 'v1' | 'v2' = 'v1'): Promise<string> {
     return ajax<string>(
        'POST',
        getUploadUrl(baseUrl, filename, apiVersion),
        content
     );
}

interface V2IndexReply {
    found: Record<string, boolean>;
}

export async function v2FilesExistOnServer(baseUrl: string, dataPath: string, files: Array<string>): Promise<Record<string, boolean>> {
    const reply: V2IndexReply = await ajax<V2IndexReply>(
        'POST',
        getUploadUrl(baseUrl, dataPath, 'v2'),
        JSON.stringify({
            files
        }),
        {
            dataType: 'text',
            headers: {
                'Content-Type': 'application/json; charset=utf-8'
            }
        }
    );

    if (typeof reply === 'string') {
        // workaround for missing `content-type` header in the v2.3.0 version
        // of the file storage plugin
        return safelyParseJSON<V2IndexReply>(reply)?.found ?? {};
    }

    return reply.found;
}